import React from "react";
import { useParams } from "react-router-dom";

const PAGES = {
  privacy: { title: "Privacy Policy", body: "This is a placeholder for the CAREMatch Privacy Policy. It describes how we collect, use, store and share your personal and health data. Formal legal review is required before this content is used in production." },
  terms: { title: "Terms of Service", body: "This is a placeholder for the CAREMatch Terms of Service. It governs your use of the CAREMatch platform. Formal legal review is required before use in production." },
  "patient-terms": { title: "Patient Terms", body: "Terms specific to patients using CAREMatch consultations, Care Passport and messaging. Placeholder — subject to legal review." },
  "doctor-terms": { title: "Doctor Terms", body: "Terms specific to clinicians providing services via CAREMatch, including verification, indemnity and payouts. Placeholder — subject to legal review." },
  cookies: { title: "Cookie Policy", body: "How CAREMatch uses cookies and similar technologies. Placeholder — subject to legal review." },
  "ai-transparency": { title: "AI Transparency", body: "CAREMatch uses AI-assisted healthcare navigation. The AI is not a diagnostic tool. All final clinical decisions rest with qualified healthcare professionals. Summaries generated by AI are clearly labelled and reviewed by clinicians." },
  accessibility: { title: "Accessibility", body: "We're committed to WCAG 2.1 AA compliance. Read our accessibility statement (placeholder — subject to review)." },
  emergency: { title: "Emergency Information", body: "CAREMatch is NOT a service for medical emergencies. If you think you are experiencing an emergency, call 999 (UK) or your local emergency number immediately, or go to A&E." },
};

export default function Legal() {
  const { page } = useParams();
  const p = PAGES[page] || { title: "Page not found", body: "This legal page doesn't exist." };
  return (
    <div className="cm-container py-14">
      <div className="max-w-3xl mx-auto">
        <div className="cm-eyebrow mb-2">Legal</div>
        <h1 className="cm-h2" data-testid={`legal-title-${page}`}>{p.title}</h1>
        <div className="cm-card mt-8 text-sm text-[#475569] leading-relaxed" data-testid={`legal-body-${page}`}>
          <p>{p.body}</p>
          <p className="mt-4 text-xs text-[#94a3b8]">Placeholder content. This page requires legal review before production use.</p>
        </div>
      </div>
    </div>
  );
}
